const sanitizeCsrf = (csrf: string | undefined): string | null => {
  if (!csrf || !csrf.length) return null;
  const decodedValue = decodeURIComponent(csrf);
  return /^[a-zA-Z0-9]+$/.test(decodedValue) ? decodedValue : null;
};

export default sanitizeCsrf;
